export default {
  methods: {
    base_url(endUrl) {
      return `
https://api.3al.com/api${endUrl}`;
      return `
http://staging2.3al.com/api${endUrl}`;
    },
    logoutUser() {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
      return this.$router.push({ name: 'auth1.sign-in1' });
    },
    runMomentDate(d) {
      return moment(d).fromNow();
    },


  }
}
